module.exports = __webpack_public_path__ + "img/file_1.321393a8.png";